import ReducerTypes from "../Types/ReducerTypes";
const INITIAL_STATE = {
  blogs: {
    items: [],
    paginationData: {},
  },
  blogsParams: {
    page: 1,
  },
  
  singleBlog: {
    items: [],
  },
  blogId: {
    id: "",
  },
};
function BlogReduser(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ReducerTypes.All_BLOGS: {
      return {
        ...state,
        blogs: {
          paginationData: action.payload.paginationData,
          items: action.payload.items,
        },
      };
    }
    case ReducerTypes.BLOGS_PARAMS: {
      const config = {};

      if (action.payload.hasOwnProperty("page")) {
        config.page = action.payload.page;
      }
      return {
        ...state,
        blogsParams: {
          ...config,
        },
      };
    }
    case ReducerTypes.SINGLE_BLOG: {
      return {
        ...state,
        singleBlog: {
          items: action.payload,
        },
      };
    }
    case ReducerTypes.BLOG_ID: {
      const config = {};

      if (action.payload.hasOwnProperty("id")) {
        config.id = action.payload.id;
      }
      return {
        ...state,
        blogId: {
          ...config,
        },
      };
    }

    default:
      return state;
  }
}
export default BlogReduser;
